





















































































































































































































































import { User } from '@/shared/user';
import { createUserTarget, UserTarget } from '@/shared/user-target';
import { DateTime } from 'luxon';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class UserTargets extends Vue {
    @Prop({ required: true }) private user!: User;

    private currentYear: number = DateTime.local().year;

    private get targetSets(): Array<{ year: number, targets: Array<UserTarget> }> {
        if (!this.user.targets.length) {
            return [];
        }

        const minimumYear: number = 2019;
        const maximumYear: number = DateTime.local().year + 1;

        const targetSets: Array<{ year: number, targets: Array<UserTarget> }> = [];

        for (let i = maximumYear; i >= minimumYear; i--) {
            targetSets.push({
                year: i, targets: [
                    this.findUserTarget(i, 1),
                    this.findUserTarget(i, 2),
                    this.findUserTarget(i, 3),
                    this.findUserTarget(i, 4),
                    this.findUserTarget(i, 5),
                    this.findUserTarget(i, 6),
                    this.findUserTarget(i, 7),
                    this.findUserTarget(i, 8),
                    this.findUserTarget(i, 9),
                    this.findUserTarget(i, 10),
                    this.findUserTarget(i, 11),
                    this.findUserTarget(i, 12),
                ],
            });
        }

        return targetSets;
    }

    private findUserTarget(year: number, month: number): UserTarget {
        return this.user.targets.find((target) => {
            const date = target.date instanceof Date ? DateTime.fromJSDate(target.date, { zone: 'UTC' }) : DateTime.fromISO(target.date, { zone: 'UTC' });
            return date.year === year && date.month === month;
        })!;
    }

    private populateUserTargets(): void {
        const minimumYear: number = 2019;
        const maximumYear: number = DateTime.local().year + 1;

        for (let year = minimumYear; year <= maximumYear; year++) {
            for (let month = 1; month <= 12; month++) {
                if (this.user.targets.some((target) => {
                    const date = target.date instanceof Date ? DateTime.fromJSDate(target.date, { zone: 'UTC' }) : DateTime.fromISO(target.date, { zone: 'UTC' });
                    return date.year === year && date.month === month;
                })) {
                    continue;
                }

                this.user.targets.push(createUserTarget(year, month));
            }
        }
    }

    private async mounted(): Promise<void> {
        this.populateUserTargets();
    }
}
